import AddMerchantForm from './AddMerchantForm';

export default AddMerchantForm;